module.exports = __webpack_public_path__ + "images/category_lp/audio_instrument/store_images/4_92d69e0728832cd3836b96c14fadf322.png";